import { persistor, store } from '../../store';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import './index.css';
import { WidgetLayout } from './WidgetLayout';

export const Widget = (props) => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <WidgetLayout {...props} />
      </PersistGate>
    </Provider>
  );
};

Widget.prototype = {
  rasaServerUrl: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  initialPayload: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  metadata: PropTypes.oneOfType([PropTypes.object, PropTypes.element]),
  botAvatar: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  widgetColor: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  botTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  botSubTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  textColor: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  userMsgBackgroundColor: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  botMsgBackgroundColor: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  botMsgColor: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  botResponseDelay: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  chatHeaderTextColor: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  buttonsCss: PropTypes.oneOfType([PropTypes.object, PropTypes.element]),
  errorMessages: PropTypes.oneOfType([PropTypes.array, PropTypes.element]),
  chatHeaderCss: PropTypes.oneOfType([PropTypes.object, PropTypes.element]),
  embedded: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
};

Widget.defaultProps = {
  rasaServerUrl: '',
  initialPayload: '/hello',
  metadata: {},
  botAvatar:
    'https://scoutfroneasset.blob.core.windows.net/frontend-asset/CTM-Butterfly-Navy_50px.png',
  widgetColor: '#131e26',
  textColor: '#ffffff',
  userMsgBackgroundColor: '#131e26',
  botTitle: 'ctm scout',
  botSubTitle: '',
  botMsgBackgroundColor: '#EBECF0',
  botResponseDelay: '',
  chatHeaderCss: {
    textColor: '#ffffff',
    backgroundColor: '#131e26',
    enableBotAvatarBorder: true
  },
  chatHeaderTextColor: '#131E26',
  botMsgColor: '#131E26',
  buttonsCss: {},
  embedded: false
};
